import { useMutation } from '@tanstack/react-query'
import { loginEmailApi } from '@!/Api/externalPayment'

export const useEmailLogin = () => {
  const mutation = useMutation({
    mutationFn: async ({ email, password }) => {
      const response = await loginEmailApi(email, password)
      return response.data
    },
  })

  return {
    login: mutation.mutate,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
  }
}
